var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"ma-auto my-10",attrs:{"elevation":"0","max-width":"1500","flat":""}},[_c('Panel'),_c('ForSales')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }